import { AdminRole } from "@repo/api-dtos"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import * as React from "react"
import { PageHeader } from "@/components/layout"
import { Skeleton } from "@/components/ui/skeleton"
import { useAdminRolesContext } from "@/contexts/admin-roles-context"
import { ModerationConfigEditor } from "@/features/moderation-config/ModerationConfigEditor"
import { useModerationConfig } from "@/queries/marketplace"

export const Route = createFileRoute("/configuration/moderation")({
	component: ModerationConfigurationPage,
})

function ModerationConfigurationPage() {
	const navigate = useNavigate()
	const { hasAnyRole, hasRole } = useAdminRolesContext()
	const canRead = hasAnyRole([
		AdminRole.Superadmin,
		AdminRole.MarketplaceUserManagement,
	])
	const canEdit = hasRole(AdminRole.Superadmin)
	const { configVersion, isLoading, error, refetch } = useModerationConfig({
		enabled: canRead,
	})

	React.useEffect(() => {
		if (!canRead) navigate({ to: "/unauthorized" })
	}, [canRead, navigate])
	if (!canRead) return null

	return (
		<div className="flex max-w-5xl flex-col gap-6 p-6">
			<PageHeader
				title="Moderation configuration"
				description="Model, thresholds and prompt of the message classifier. Each save is a new version, used from the pipeline's next poll."
			/>
			{error ? (
				<p className="rounded-lg bg-bad-soft px-3 py-2 text-bad">
					Failed to load the configuration: {error.message}
				</p>
			) : isLoading || !configVersion ? (
				<div className="flex flex-col gap-3">
					<Skeleton className="h-[58px] w-full" />
					<Skeleton className="h-[58px] w-full" />
					<Skeleton className="h-[58px] w-full" />
					<Skeleton className="h-[58px] w-full" />
				</div>
			) : (
				<ModerationConfigEditor
					active={configVersion}
					canEdit={canEdit}
					onReload={() => refetch()}
				/>
			)}
		</div>
	)
}
